import { render, staticRenderFns } from "./SfTableRow.vue?vue&type=template&id=3c48e8e2&"
import script from "./SfTableRow.vue?vue&type=script&lang=ts&"
export * from "./SfTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports